<div class="schema-values-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">{{ title }}</h2>
    <button mat-icon-button class="close-button" aria-label="Close" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <app-variable-schema-form
      [schema]="data.schema"
      [initialValues]="data.initialValues"
      (valuesChange)="onSchemaValuesChange($event)"
      (validChange)="onSchemaValidChange($event)">
    </app-variable-schema-form>
  </div>

  <div class="dialog-actions">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary"
            (click)="onRun()"
            [disabled]="!schemaValid">
      <mat-icon>play_arrow</mat-icon>
      {{ confirmLabel }}
    </button>
  </div>
</div>
